import { a, DisplayMode } from "../utils";

export const setDisplayMode = (displayMode: Map<string, DisplayMode>) => a({ type: "SET_DISPLAY_MODE", displayMode});
